ko.bindingHandlers.number = {
	init: function (element, valueAccessor, allBindingsAccessor) {
		var value = ko.utils.unwrapObservable(valueAccessor());
		$(element).html( parseFloat( value).toFixed(2) )
	}
};
